import React from 'react';
import { ArrowUp, ArrowDown } from 'lucide-react';

const VITALS = [
  { key: 'bp', label: 'BP', suffix: '' },
  { key: 'heart_rate', label: 'HR', suffix: '' },
  { key: 'oxygen_saturation', label: 'SpO2', suffix: '%' },
  { key: 'respiratory_rate', label: 'RR', suffix: '' },
  { key: 'temperature', label: 'Temp', suffix: '°F' },
  { key: 'pain_level', label: 'Pain', suffix: '/10' },
];

const num = (v) => parseFloat(String(v).split('/')[0]);

export const PatientVitalsGrid = ({ patientId, vitals, lastResponse }) => {
  const changed = {};
  (lastResponse?.changes || []).forEach((c) => { changed[c.vital] = c; });
  const improved = lastResponse?.outcome === 'improved';

  return (
    <div className="grid grid-cols-3 gap-2 text-xs mb-3" data-testid={`vitals-grid-${patientId}`}>
      {VITALS.map(({ key, label, suffix }) => {
        const change = changed[key];
        const tone = change ? (improved ? 'bg-emerald-50 ring-1 ring-emerald-300' : 'bg-red-50 ring-1 ring-red-300') : 'bg-slate-50';
        const Arrow = change && num(change.to) > num(change.from) ? ArrowUp : ArrowDown;
        return (
          <div key={key} className={`p-2 rounded transition-colors duration-500 ${tone}`} data-testid={`vital-${key}-${patientId}`}>
            <span className="text-slate-600">{label}:</span>
            <span className="ml-1 font-bold text-slate-900">{vitals?.[key]}{suffix}</span>
            {change && (
              <Arrow className={`inline w-3 h-3 ml-1 ${improved ? 'text-emerald-700' : 'text-red-700'}`} data-testid={`vital-change-${key}-${patientId}`} />
            )}
          </div>
        );
      })}
    </div>
  );
};

export const PatientResponseNote = ({ patientId, response }) => {
  if (!response) return null;
  const tone = response.outcome === 'improved' ? 'bg-emerald-50 border-emerald-200 text-emerald-800'
    : response.outcome === 'no_change' ? 'bg-amber-50 border-amber-200 text-amber-900' : 'bg-red-50 border-red-200 text-red-800';
  return (
    <p
      className={`text-xs mb-3 px-2 py-1.5 rounded border ${tone}`}
      data-testid={`patient-response-note-${patientId}`}
    >
      {response.message}
    </p>
  );
};
